<template>
    <div class="login-box well white-box">
        <logo-component></logo-component>
        <div class="alert alert-danger" v-if="error">
            <p>{{ error_message }}</p>
        </div>
        <div class="alert alert-success" v-if="success">
            <p>
                An email was sent with the instructions to reset your password.
                <b-link class="" :to="{ name : 'login' }" >
                    <a>Back to Login</a>
                </b-link>
            </p>
        </div>
        <b-form v-if="!success" @submit.prevent="onSubmit">
            <b-form-group
                    label="Email:"
                    label-for="email">
                <b-form-input
                        name="email"
                        id="email"
                        v-model="email"
                        type="text"
                        v-validate="{ required:true }"
                        :state="errors.has('email') ? false : null"
                        placeholder="user@example.com">
                </b-form-input>
                <em v-if="errors.has('email')" class="text-danger">
                    {{ errors.first('email') }}
                </em>
            </b-form-group>
            <b-form-group>
                <b-button type="submit" variant="primary"
                    :disabled="loading">
                    <span>Send reset password</span>
                    <b-spinner
                        v-if="loading"
                        small
                        class="ml-2" />
                </b-button>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
    import LogoComponent from './Logo.vue';

    export default {
        name: "RecoverPassword",
        components: {
            LogoComponent
        },
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                email: '',
                error: '',
                error_message: '',
                success: '',
                loading: false
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.loading = true;
                        axios.post('/users/password/recover', {
                            "email": this.email,
                        })
                            .then(() => {
                                this.error = false;
                                this.success = true;
                                this.loading = false;
                            })
                            .catch((error) => {
                                this.error = true;
                                this.error_message = error.response.data.message;
                                this.loading = false;
                            })
                    }
                });
            },
        },
        mounted() {
            $('html').addClass('login');
        },
    }
</script>

<style scoped>

</style>